export const GalleryData = [
    {
      id: 1,
      title: "Islamic Calligraphy",
      image: "/img1.jpg"
    },
    {
      id: 3,
      title: "Mosque Architecture",
      image: "/img7.jpg", // Sheikh Lotfollah Mosque dome
    },
    {
      id: 4,
      title: "Mosque Architecture",
      image: "/img6.jpg", // Interior of Sheikh Lotfollah Mosque
    },
    {
      id: 2,
      title: "Islamic Calligraphy",
      image: "/img5.webp", // Mosque calligraphy
    },
    {
      id: 5,
      title: "Geometric Patterns",
      image: "/img8.webp", // Alhambra pattern
    },
    {
      id: 6,
      title: "Geometric Patterns",
      image: "/img9.jpg", // Muqarnas ceiling
    },
    {
      id: 10,
      title: "Quranic Verses",
      image: "/img3.jpg", // Quran page Calligraphy
    },
    
    {
        id: 9,
        title: "Quranic Verses",
        image: "/img10.webp", // Al-Fatiha calligraphy
    },
  
    
  
  ];
  